import { motion } from 'framer-motion';
import { useTheme } from '../../hooks/useThemeToggle';

export const ThemeToggle = ({ size = 'default' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const w = size === 'sm' ? 40 : 48;
  const h = size === 'sm' ? 22 : 26;
  const knobSize = size === 'sm' ? 16 : 20;
  const offset = size === 'sm' ? 3 : 3;

  return (
    <button
      onClick={(e) => { e.stopPropagation(); toggleTheme(); }}
      className="relative rounded-full transition-colors duration-300 flex items-center flex-shrink-0 cursor-pointer z-10"
      style={{
        width: w,
        height: h,
        background: isDark ? 'var(--nexus-bg-tertiary)' : '#E2E8F0',
      }}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      data-testid="theme-toggle"
    >
      <motion.div
        animate={{ x: isDark ? w - knobSize - offset * 2 : 0 }}
        transition={{ type: 'spring', stiffness: 500, damping: 30 }}
        className="flex items-center justify-center rounded-full shadow-sm pointer-events-none"
        style={{
          width: knobSize,
          height: knobSize,
          marginLeft: offset,
          background: isDark ? '#334155' : '#FFFFFF',
          boxShadow: isDark ? '0 0 8px rgba(30, 78, 140, 0.3)' : '0 1px 3px rgba(0,0,0,0.15)',
        }}
      >
        {isDark ? (
          <svg width={knobSize - 6} height={knobSize - 6} viewBox="0 0 16 16" fill="none">
            <path d="M14 8.5a6 6 0 01-7.5 5.8A6 6 0 018.5 2a6 6 0 005.5 6.5z" fill="#1E4E8C" />
          </svg>
        ) : (
          <svg width={knobSize - 6} height={knobSize - 6} viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="3.5" fill="#92580A" />
            <path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.05 3.05l1.41 1.41M11.54 11.54l1.41 1.41M3.05 12.95l1.41-1.41M11.54 4.46l1.41-1.41" stroke="#92580A" strokeWidth="1.2" strokeLinecap="round" />
          </svg>
        )}
      </motion.div>
    </button>
  );
};
